<template>
  <v-stepper v-model="stepper" @change="changeStep">
    <v-stepper-header class="stepper-gruppi">
      <v-stepper-step
        v-for="(st, idx) in elencoChecklist" 
        :key="idx"
        :complete="stepper === parseInt(idx) + 1"
        editable
        :step="parseInt(idx) + 1"
      >
        <!-- <v-badge color="success" :value="st.completa" icon="mdi-check" offset-x="-2" offset-y="2" title="Numero di elementi trovati per la ricerca effettuata"> -->
          {{ st.titolo }}
        <!-- </v-badge> -->
      </v-stepper-step>
    </v-stepper-header>
    <v-stepper-items>
      <v-stepper-content v-for="(st, idx) in trigger && elencoChecklist" :key="idx" :step="parseInt(idx) + 1">
        <v-row>
          <v-col cols="4">
            <v-card>
              <v-card-title class="text-h5">
                {{ st.titolo }}
              </v-card-title>
              <v-card-subtitle>{{ st.descrizione }}</v-card-subtitle>
              <v-data-table
                dense
                :headers="headers"
                :items="st.passi"
                class="elevation-1 mr-5 ml-5"
                @click:row="clickRow"
                hide-default-header
                hide-default-footer
                :items-per-page="(st && st.passi.length) || 10"
                >
                <template v-slot:[`item.checked`]="{ item }">
                  <v-switch dense v-model="item.checked" inset class="ml-5 mb-2" hide-details @change="onSwitch(st, item)"></v-switch>
                </template>
                <template v-slot:[`item.titolo`]="{ item }">
                  {{ item.titolo }}
                  <small v-if="!!item.hint"><br />{{ item.hint }}</small>
                  <!-- <v-switch dense v-model="item.checked" :label="item.titolo" inset class="ml-5 mb-2" :hint="item.hint" :persistent-hint="!!item.hint" hide-details="auto"></v-switch> -->
                </template>                 
              </v-data-table>
<!--                 <v-simple-table dense>
                  <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left"></th>
                    </tr>
                  </thead>
                    <tbody>
                      <tr v-for="(cl, index) in st.passi" :key="index">
                        <td><v-switch dense v-model="cl.checked" :label="cl.titolo" inset class="ml-5 mb-2" :hint="cl.hint" :persistent-hint="!!cl.hint" hide-details="auto"></v-switch></td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table> -->
              <v-card-text></v-card-text>
              <v-card-actions>
                <v-btn text>
                  
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
          <v-col>
            <v-card>
              <v-card-title class="text-h5">Note</v-card-title>
              <v-card-subtitle>{{ rigaDescrizioneNote }}</v-card-subtitle>
              <v-card-text>
                {{ rigaNota }}
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-stepper-content>
    </v-stepper-items>
<!-- 


    <div v-for="(st, idx) in elencoChecklist" :key="idx">
      <v-stepper-step :complete="stepper > idx + 1" :step="idx + 1">
        {{ st.titolo }}
        <small>{{ st.descrizione }}</small>
      </v-stepper-step>
      <v-stepper-content :step="idx + 1">
        <v-card>
            <v-simple-table dense>
              <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left"></th>
                </tr>
              </thead>
                <tbody>
                  <tr v-for="(cl, index) in st.checklist" :key="index">
                    <td><v-switch dense v-model="cl.checked" :label="cl.title" inset class="ml-5 mb-2" :hint="cl.hint" :persistent-hint="cl.hint" hide-details="auto"></v-switch></td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          <v-card-text></v-card-text>
          <v-card-actions>
            <v-btn text>
              
            </v-btn>
          </v-card-actions>
        </v-card>
        <v-btn color="primary" @click="stepper = idx + 2">Continue</v-btn>
        <v-btn text>Cancel</v-btn>
      </v-stepper-content>
    </div> -->
  </v-stepper>
</template>

<script>
  import impostazioni from '@/services/impostazioniService.js'

  export default {
    props: {
      cliente: Object
    },
    data() {
      return {
        elencoChecklist: [],
        stepper: 0,
        step: 0,
        headers: [
          {
            text: '',
            align: 'start',
            sortable: false,
            value: 'checked',
            width: '5%'
          },
          {
            text: '',
            align: 'start',
            sortable: false,
            value: 'titolo'
          }
        ],
        rigaDescrizioneNote: '',
        rigaNota: '',
        trigger: 1
      }
    },
    async mounted() {
      const elenco = await impostazioni.getElencoChecklist() || []
      elenco.forEach(el => this.elencoChecklist.push(el))
      
      await this.$nextTick()
      this.stepper = 1
      await this.changeStep(this.stepper)
    },
    methods: {
      clickRow(item) {
        this.rigaDescrizioneNote = item.descrizioneNote || ''
        this.rigaNota = item.note || ''
      },
      async onSwitch(st, item) {
        await impostazioni.setChecklistValue(this.cliente.codice, st.codice, item.codice, item.checked)
        st.completa = !st.passi.some(x => !x.checked)
      },
      async changeStep(step) {
        let chk = this.elencoChecklist[step - 1]
        const ckCliente = await impostazioni.getChecklistCliente(this.cliente.codice, chk.codice)
        if (ckCliente && ckCliente.passi) {
          for (let c of ckCliente.passi) {
            let item = chk.passi.find(x => x.codice === c.codice)
            item.checked = c.checked
          }
        }
        chk.completa = chk.passi.length > 0 && !chk.passi.some(x => !x.checked)
      }
    }
  }
</script>
